import { GridResultsDataElem } from 'model/reports/GridResults';
import { GridRequiredStrategy } from '@ax2/common/model/schemas/GridRequiredOptions';

export const getPercentForGrid = (
  strategy: GridRequiredStrategy,
  elem: GridResultsDataElem
): number => {
  switch (strategy) {
    case GridRequiredStrategy.AtLeastOnePerColumn:
      return elem.totalCompletesPercent;
    case GridRequiredStrategy.OnePerColumn:
      return elem.columnPercent;
    case GridRequiredStrategy.AtLeastOnePerRow:
      return elem.totalCompletesPercent;
    case GridRequiredStrategy.OnePerRow:
      return elem.rowPercent;
    case GridRequiredStrategy.All:
      return elem.columnPercent;
  }
};

export const getPercentLabelForGrid = (
  strategy: GridRequiredStrategy
): string => {
  const columnLabel = 'Column';
  const rowLabel = 'Row';
  const completesTotalLabel = '';
  switch (strategy) {
    case GridRequiredStrategy.AtLeastOnePerColumn:
      return completesTotalLabel;
    case GridRequiredStrategy.OnePerColumn:
      return columnLabel;
    case GridRequiredStrategy.AtLeastOnePerRow:
      return completesTotalLabel;
    case GridRequiredStrategy.OnePerRow:
      return rowLabel;
    case GridRequiredStrategy.All:
      return columnLabel;
  }
};
